export default __webpack_public_path__ + "aed553835b4a9ff72df09f5b68b37238.svg";